import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render } from "react-dom"
import { Events, Loading, ModalContainer } from "web/components"
import { TLOContextProvider } from "web/contexts"
import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"

export default class HistoryController extends Controller {
  static values = {
    subjectType: String,
    subjectId: Number,
    userPermissions: Object,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const contextProviderData = {
      id: this.subjectIdValue,
      user_permissions: this.userPermissionsValue,
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <TLOContextProvider
                subjectType={this.subjectTypeValue}
                data={contextProviderData}
              >
                <Events />
              </TLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
